import { Bet } from '@/modules/report/slice/betRecord';

export type BlackjackResultRecordPanelProps = {
    bet: Bet;
};
export const BlackjackResultRecordPanel = () => {
    return <></>;
};
